module.exports = __webpack_public_path__ + "c2b28c17ecc4f2db4c23ae8ca631470f.png";